module.exports = __webpack_public_path__ + "static/marathon-c6cf1e3d5848a11edec80899836971b2.jpg";